module.exports = __webpack_public_path__ + "img/33.fe49ce9.png";